import { ordersApi, brokersApi } from '../../services/api';

// buy order APIs
export const getProcessedBuyInstructions = () => ordersApi.getProcessedBuyInstructions();
export const getInProgressBuyOrders = () => ordersApi.getInProgressBuyOrders();
export const getCalculatedBuyOrders = (params: any) => ordersApi.getCalculatedBuyOrders(params);
export const getCompletedBuyOrders = (params: any) => ordersApi.getCompletedBuyOrders(params);
export const processBuyOrders = (data: { order_ids: number[], block_trade?: boolean }) => ordersApi.processBuyOrders(data);
export const submitCalculatedOrders = (data: { order_ids: number[], email_recipients?: string[] }) => ordersApi.submitCalculatedOrders(data);
export const bulkAssignBroker = (orderIds: number[], brokerId: number | null) => brokersApi.bulkAssignBroker('buy', orderIds, brokerId);
export const deleteBuyOrder = (data: { order_ids: number[] }) => ordersApi.deleteBuyOrders(data)


// sell order APIs
export const getProcessedSellInstructions = () => ordersApi.getProcessedSellInstructions();
export const getInProgressSellOrders = () => ordersApi.getInProgressSellOrders();
export const getCalculatedSellOrders = (params: any) => ordersApi.getCalculatedSellOrders(params);
export const getCompletedSellOrders = (params: any) => ordersApi.getCompletedSellOrders(params);
export const processSellOrders = (data: { order_ids: number[], block_trade?: boolean }) => ordersApi.processSellOrders(data);
export const submitCalculatedSellOrders = (data: { order_ids: number[], email_recipients?: string[] }) => ordersApi.submitCalculatedSellOrders(data);
export const bulkAssignSellBroker = (orderIds: number[], brokerId: number | null) => brokersApi.bulkAssignBroker('sell', orderIds, brokerId);
export const deleteSellOrder = (data: { order_ids: number[] }) => ordersApi.deleteSellOrders(data)



// common APIs
export const getBrokersByScheme = (schemeId: number, clientId?: number) => brokersApi.getBrokersByScheme(schemeId, clientId);
